
import Reply from "../../../assets/filled/Reply.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ReplyIcon({ className, dataTestid = "ReplyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Reply data-testid={dataTestid} className={classes} {...rest} />
  );
}
